import { Box, Grid, Typography } from '@mui/material';

import { useAuthContext } from 'src/contexts/AuthProvider';

interface GridHeaderProps {
    additionalCharges?: boolean;
    additionalTarrifs?: boolean;
}

export const GridHeader: React.FC<GridHeaderProps> = ({
    additionalCharges = false,
    additionalTarrifs = false,
}) => {
    const { usersCurrency } = useAuthContext();

    const cardStyles = {
        backgroundColor: '#F39E4E',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '4px',
    };

    return (
        <Grid container spacing={2} mb="8px">
            {/* Heading */}
            {additionalCharges || additionalTarrifs ? (
                <>
                    {additionalCharges ? (
                        <>
                            <Grid item xs={4}>
                                <Typography fontSize="20px" color="#575757">
                                    Purchases
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Box sx={cardStyles}>
                                    <Typography fontSize="20px">Credit Card</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box sx={cardStyles}>
                                    <Typography fontSize="20px">Debit Card</Typography>
                                </Box>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid item xs={6}>
                                <Typography fontSize="20px" color="#575757">
                                    Name or Charge
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography fontSize="20px" color="#575757">
                                    Amount
                                </Typography>
                            </Grid>
                        </>
                    )}
                </>
            ) : (
                <>
                    <Grid item xs={4} />
                    <Grid item xs={2}>
                        <Typography fontSize="20px" color="#575757">
                            Purchases
                        </Typography>
                    </Grid>
                    <Grid item xs={2} />
                    <Grid item xs={2}>
                        <Typography fontSize="20px" color="#575757">
                            Refunds
                        </Typography>
                    </Grid>
                    <Grid item xs={2} />
                </>
            )}
            {/* Labels */}
            {!additionalTarrifs && (
                <>
                    <Grid item xs={4} />
                    <Grid item xs={2}>
                        <Typography fontSize="14px" color="#1D1D1B" fontWeight={600}>
                            %
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography fontSize="14px" color="#1D1D1B" fontWeight={600}>
                            {usersCurrency} Per Item
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography fontSize="14px" color="#1D1D1B" fontWeight={600}>
                            %
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography fontSize="14px" color="#1D1D1B" fontWeight={600}>
                            {usersCurrency} Per Item
                        </Typography>
                    </Grid>
                </>
            )}
        </Grid>
    );
};
